export const SET_EXPERIMENTAL_FEATURE_IS_ENABLED = 'app/experimentalFeatures/SET_EXPERIMENTAL_FEATURE_IS_ENABLED';
export const DISABLE_ALL_FEATURES = 'app/experimentalFeatures/DISABLE_ALL_FEATURES';
